import { ESplaceni } from 'enums/isin/udaje/splaceni';

const splaceniSelect = [
    {
        value: ESplaceni.H,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_SPLACENI_SH'
    },
    {
        value: ESplaceni.F,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_SPLACENI_FS'
    },
    {
        value: ESplaceni.V,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_SPLACENI_VV'
    },
    {
        value: ESplaceni.O,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_SPLACENI_O'
    }
];

export default splaceniSelect;
